import { RatingBadge } from '@/ui/RatingBadge';
import { useRatings, type ChesscomCadence } from '@/api/ratings';

/**
 * ChesscomTab — onglet chess.com détaillé (T6 P1 Stats Hub).
 *
 * 4 cards principales : Rapide / Blitz / Daily / Tactique. Bullet relégué
 * derrière un disclosure "Voir bullet" (hiérarchie ROADMAP §314 :
 * "Bullet caché par défaut").
 *
 * Pas de lien profil chess.com personnalisé : le `chesscom_username` n'est
 * pas exposé dans `AuthUser` (cf. auth/types.ts), seulement persisté côté
 * backend. Renvoyer vers chess.com en générique.
 */

const CC_PRIMARY: ChesscomCadence[] = ['rapid', 'blitz', 'daily', 'tactics'];
const CC_HIDDEN: ChesscomCadence[] = ['bullet'];

export function ChesscomTab(): JSX.Element {
  const ratings = useRatings();

  return (
    <div className="flex flex-col gap-6">
      <section>
        <div className="flex items-center justify-between gap-3 flex-wrap mb-3">
          <div>
            <h2 className="text-heading-3 text-paper-50 m-0">
              <span style={{ color: 'var(--amber-500)' }}>chess.com</span>
              <span className="text-ink-300 text-body ml-2 font-mono uppercase tracking-wider">
                volume
              </span>
            </h2>
            <p className="text-body-sm text-ink-300 italic mt-1">
              Mis à jour automatiquement (cron quotidien).
            </p>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
          {CC_PRIMARY.map((cad) => {
            const r = ratings.data?.chesscom?.[cad] ?? null;
            return (
              <RatingBadge
                key={cad}
                platform="chesscom"
                cadence={cad}
                value={r?.value ?? null}
                updatedAt={r?.updated_at ?? null}
                variant="card"
              />
            );
          })}
        </div>
      </section>

      <details className="rounded-xl border border-ink-700 bg-ink-800 p-4">
        <summary className="text-caption uppercase tracking-widest text-ink-300 cursor-pointer hover:text-paper-50">
          Voir bullet
        </summary>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mt-3">
          {CC_HIDDEN.map((cad) => {
            const r = ratings.data?.chesscom?.[cad] ?? null;
            return (
              <RatingBadge
                key={cad}
                platform="chesscom"
                cadence={cad}
                value={r?.value ?? null}
                updatedAt={r?.updated_at ?? null}
                variant="card"
              />
            );
          })}
        </div>
      </details>
    </div>
  );
}
